<template>
  <div>

    <section class="hero is-light m-2">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            {{ news.title }}
          </h1>
        </div>
      </div>
    </section>

    <section class="section is-medium">
      <div class="container">
        <img :src="mainimg" :alt="news.title">

        <div class="subtitle mt-05 has-text-justified" v-html="news.content">

        </div>

        <h1 class="title mt-2">
          Galería
        </h1>

        <div class="columns" v-for="images in chunkedImg">
          <div class="column is-4" v-for="img in images">
            <img :src="'https://api.plataformasocialmedia.pw'+img.path+'/medium/'+img.file_name" :alt="news.title" @click="imageSelected('https://plataformasocialmedia.pw'+img.path+'/'+img.file_name)">
          </div>
        </div>

      </div>
    </section>

    <modal v-show="showModal" :imageselected="imageselected" @close="showModal = false"></modal>

  </div>
</template>

<script>
import axios from 'axios';
import VueLodash from 'vue-lodash'
import headerimg from '@/assets/img/banercroc.png'
import Modal from '@/components/layouts/partials/modal'

export default {
  name: 'NoticiasPage',
  data () {
    return {
      news:[],
      imgheader:headerimg,
      mainimg:'',
      images:[],
      showModal: false,
      imageselected:'',
    }
  },
  components: {
    Modal

  },
  computed: {
   chunkedImg () {
     return _.chunk(this.images,3)
   }
  },
  methods:{
    init(){
      var self = this;
      axios.post(process.env.API_URL_V1+'getnew?api_token='+process.env.API_TOKEN_V1, {type_web:'croc',slug:this.$route.params.slug})
      .then(function (response) {
        self.news=response.data.data;
        self.images=response.data.data.images;
        self.mainimg='https://api.plataformasocialmedia.pw'+response.data.data.images[0].path+'/'+response.data.data.images[0].file_name;
      })
      .catch(function (error) {
      });
    },
    imageSelected(img){
      this.imageselected=img;
      this.showModal = true;
    },
  },
  created :function(){
    this.init();
  }
}
</script>

<style>
.mt-2{
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/NoticiasPage.vue